module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-demi-9638358e.svg";